const textAreaStyles = {
  padding: '5px 7px',
};

export default textAreaStyles;
